<h2 mat-dialog-title translate="CALLS.EXTEND_RETENTION.TITLE"></h2>
<mat-dialog-content>
  <p>{{ 'CALLS.EXTEND_RETENTION.DESCRIPTION' | translate: { callName: data.callName } }}</p>
  <div class="current-deletion-date">
    <span class="label" translate="CALLS.EXTEND_RETENTION.CURRENT_DELETION_DATE"></span>: {{ currentDeletionDate | date: dateTimeFormat }}
    @if (maximumDeletionDate !== null) {
      <div><span class="label" translate="CALLS.EXTEND_RETENTION.MAXIMUM_DELETION_DATE"></span>: {{ maximumDeletionDate | date: dateTimeFormat }}</div>
    }
  </div>
  <div class="date-picker-section">
    <app-datetime-picker
      [(ngModel)]="deletionDate"
      name="deletion-date"
      translationKey="CALLS.EXTEND_RETENTION.NEW_DELETION_DATE"
      [isDateInvalid]="!isDeletionDateValid"
      [errorMessageKey]="errorMessageKey"
      [max]="maximumDeletionDate"
    ></app-datetime-picker>
    <p class="local-time">{{ 'COMMON.ALL_TIMES_IN_TIME_ZONE' | translate: { timeZone: localTimeZone } }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="actions" align="end">
  <button mat-button [mat-dialog-close]="null" translate="COMMON.CANCEL"></button>
  <button mat-button [mat-dialog-close]="dialogResult" [disabled]="!isDeletionDateValid" translate="COMMON.SAVE" color="primary"></button>
</mat-dialog-actions>
